import { render, staticRenderFns } from "./NewBlip.vue?vue&type=template&id=a60b8c10&scoped=true&"
import script from "./NewBlip.vue?vue&type=script&lang=ts&"
export * from "./NewBlip.vue?vue&type=script&lang=ts&"
import style0 from "./NewBlip.vue?vue&type=style&index=0&id=a60b8c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60b8c10",
  null
  
)

export default component.exports